import api from '@/api'

export default {
  async getAccount() {
    return api.account.getMe()
  },

  async updateAccount(context, payload) {
    return api.account.update(
      payload.organizationId,
      payload.accountId,
      payload.data
    )
  },
}
